const updates = [
  { time: '刚刚', title: '某女星被拍到深夜出入整容医院，疑似修复失败紧急返工', tag: '整容对比' },
  { time: '5分钟前', title: '热门综艺录制现场突发设备故障，录制被迫中断3小时', tag: '综艺翻车' },
  { time: '12分钟前', title: '知名导演新片选角内幕曝光，资本方指定女主角引争议', tag: '剧组路透' },
  { time: '25分钟前', title: '网红直播带货数据造假实锤，后台真实销量不足公布的10%', tag: '网红黑料' },
  { time: '38分钟前', title: '某男团成员被曝私联粉丝，聊天记录尺度惊人', tag: '私生饭事件' },
  { time: '50分钟前', title: '颁奖礼后台打架细节流出：两人因站位问题大打出手', tag: '吃瓜爆料' },
  { time: '1小时前', title: '影视公司CEO涉嫌偷税被调查，旗下多位艺人配合取证', tag: '偷税漏税' },
  { time: '1.5小时前', title: '某综艺PD私下吐槽嘉宾耍大牌，录音意外流出', tag: '综艺翻车' },
  { time: '2小时前', title: '代孕事件最新进展：第三位艺人被爆牵涉其中', tag: '代孕风波' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-2">最新快讯</h2>
        <p className="text-foreground-500 text-sm text-center mb-8">滚动更新，不错过任何一条爆料</p>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 before:absolute before:left-[11px] before:top-2 before:bottom-2 before:w-[2px] before:bg-background-300">
            {updates.map((item, idx) => (
              <a
                key={idx}
                href="#updates"
                className="relative block pb-6 last:pb-0 group cursor-pointer"
              >
                <div className="absolute left-[-32px] top-1 w-[22px] h-[22px] rounded-full border-2 border-background-300 bg-background-100 group-hover:border-primary-400 transition-colors duration-200 flex items-center justify-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-500 scale-0 group-hover:scale-100 transition-transform duration-200"></div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-xs text-foreground-400 whitespace-nowrap mt-0.5 shrink-0">{item.time}</span>
                  <div className="min-w-0">
                    <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors leading-snug">
                      {item.title}
                    </h3>
                    <span className="inline-block mt-1 text-[11px] text-accent-600 bg-accent-50 px-1.5 py-0.5 rounded whitespace-nowrap">{item.tag}</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}